module.exports = {
  BooleanWidget: require('./BooleanWidget').default,
  ColorWidget: require('./ColorWidget').default,
  InputWidget: require('./InputWidget').default,
  NumberWidget: require('./NumberWidget').default,
  SelectWidget: require('./SelectWidget').default,
  TextureWidget: require('./TextureWidget').default,
  Vec4Widget: require('./Vec4Widget').default,
  Vec3Widget: require('./Vec3Widget').default,
  Vec2Widget: require('./Vec2Widget').default
};



// WEBPACK FOOTER //
// ./src/components/widgets/index.js